import {Outlet} from 'react-router'
import PropTypes from 'prop-types'

import withProviders from '~/react/contexts/withProviders'
import {AuthProvider} from '~/react/contexts/authentication'
import Loading from '~/react/components/Loading'

export const ProviderLayout = withProviders(({authenticityToken}) => {
  return (
    <AuthProvider authenticityToken={authenticityToken}>
      <Loading>
        <Outlet />
      </Loading>
    </AuthProvider>
  )
})

ProviderLayout.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  variant: PropTypes.string,
}
